var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8175 23.0973C16.5173 25.8366 15.7909 30.1738 15.5903 32C15.2532 26.9198 13.1223 22.62 12.099 21.1051C9.69126 18.0171 3.02977 16.4981 0 16.1245C2.64854 15.751 8.59573 14.3813 11.1961 11.8911C13.7965 9.40078 15.1288 2.92607 15.4699 0C15.8511 2.57328 17.1192 8.45448 19.1417 11.393C21.1643 14.3315 27.89 15.7717 31 16.1245C30.1573 16.3113 27.8699 16.8218 25.4621 17.3696C22.4524 18.0545 19.4427 19.6732 17.8175 23.0973Z",
    fill: "#FCBE13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.f43f6138b6ed0c35adb50b1d305f6253.svg";
export { ForwardRef as ReactComponent };